export enum RunsFolderTreeActions {
  BUILT_FOLDER_TREE,
  FOLDER_SEARCH,
  CLEAR_SELECTED_ROWS,
  SELECT_ROW,
  NODE_SELECTED,
  FOLDER_LOADED,
}
